import { render, staticRenderFns } from "./BulkQuotesList.vue?vue&type=template&id=3ae8b2e6"
import script from "./BulkQuotesList.vue?vue&type=script&lang=js"
export * from "./BulkQuotesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports